<template>
    <div class="echart-box">
        <v-chart :options="option" ref="my" autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar';
import 'zrender/lib/svg/svg'
export default {
    name:"char1",
    components:{
         'v-chart': ECharts
    },
    props:{
        data:Object,
        tipname:String,
        datelist:{
            type:Array,
            default:()=>{
              return []
            }
        }
    },
    data(){
        return {
            option:{},
             viewdata:{},
             viewdate:[],
             timer:false
        }
    },
     watch:{
        datelist:{
            handler(){  
                          
              this.dataInit();
              this.init()
            },
            deep:false
        }
    },
    methods:{
        dataInit(){              
            this.viewdata.data1= this.data.saleTotal.slice(0,5); 
            
            this.viewdate=this.datelist.slice(0,5);    
           this.doit()
        },
        init(){            
             let that=this
              this.option={
                grid: {
                    top:'8%',
                    left: '5%',
                    right: '5%',
                    bottom:'10%',
                    containLabel: true
                },
               
                tooltip:{
                    formatter: function(params,index) {    
                    　　var result = params[0].name+'</br>'
                    　　params.forEach(function (item) {                              
                            if(item.seriesId=="a1"){                            
                                var name=that.tipname==undefined?"销售额":that.tipname
                                result += name +":"+ item.data + "</br>"
                            }else if(item.seriesId=="a2"){ //活跃会员数                            
                                if(item.data>10000){
                              　    result += item.seriesName +":"+ (item.data/10000) + "万</br>"
                                }
                                else{                                
                                  　result += item.seriesName +":"+ item.data + "</br>"
                                }
                            }else if(item.seriesId=="a3"){ //活跃会员数                            
                                result += item.seriesName +":"+ item.data + "%</br>"
                            }                            
                            else{
                              result += item.seriesName +":"+ item.data + "</br>"
                            }                          
                           
                    　　})                   
                    　　return result                
                    },
                    textStyle:{
                        fontSize:14
                    },
                    trigger: "axis",
                    axisPointer: {
                        type: "line",      
                        lineStyle:{
                            color: "#377dff"
                        }  
                    }
                },                
                xAxis: {          
                        boundaryGap: false,          
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'solid',
                            width:1,
                        },
                        minInterval:0
                    },
                    axisLabel: {             
                      color:'#fff'
                    },
                    type: 'category',                              
                    data: this.viewdate,
                },
                yAxis: {
                    axisLabel: {             
                      color:'#fff'
                    },
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'dashed',
                            width:1,
                        },
                        minInterval:0
                    },
                    type: 'value'
                },
                series: [{
                    id:'a1',
                    name:this.tipname==""?"销售额":this.tipname,
                    smooth:0.7,
                    areaStyle: {
                        color:'rgba(55,125,255,0.2)'
                    },
                    data: this.viewdata.data1,
                    type: 'line',
                    itemStyle:{
                        normal:{ 
                            color:"#377dff"
                        }                  
                    }                  
                }]
            }                        
            setTimeout(()=>{
                  this.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex: 1                     
                    })
                this.$nextTick(()=>{
                    this.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex: 2                     
                    })
                })
            },500) 
            // this.doit()
           
        },
        runData(){
            this.data.saleTotal.push(this.data.saleTotal.shift())
           this.datelist.push(this.datelist.shift());   
            
        },
        //动画
        doit(){    
             let that=this
            if(this.timer){
                window.clearTimeout(that.timer);
            }
            this.timer= setTimeout(()=>{                             
                that.runData()
            },3000)       
            
        },
    },
    mounted(){
        //   this.init()
    }
}
</script>